"use client";

import { Builder } from "@builder.io/react";
import { BuilderContent } from "@builder.io/sdk";
import "@builder.io/widgets/dist/lib/builder-widgets-async";
import dynamic from "next/dynamic";
import { notFound } from "next/navigation";

// Temporary import the builder component dynamically.
// Prevents 500 errors on every page load
// To be removed once builder.io fixes the emotion/core issue
// https://forum.builder.io/t/500-error-on-initial-load-in-next-js-app-and-edge-runtime/6314/5
const BuilderComponent = dynamic(() => import("@builder.io/react").then((mod) => mod.BuilderComponent), { ssr: false });
interface BuilderPageProps {
  content: BuilderContent | undefined | null;
  model: string;
}

export default function RenderBuilderContent({ content, model }: BuilderPageProps) {
  if (!content && !Builder.isPreviewing && !Builder.isEditing) {
    return notFound();
  }

  return <BuilderComponent content={content ?? undefined} model={model} />;
}
